import React, { useEffect, useState } from 'react';
import { Box, VStack, Text, Link } from '@chakra-ui/react';
import { useLegalLang } from '../LegalLangContext';

// Auto-highlight section active dùng IntersectionObserver.
// Section visible nhiều nhất sẽ được active.
const TableOfContents = ({ items }) => {
  const { t } = useLegalLang();
  const [activeId, setActiveId] = useState(items[0]?.id);

  useEffect(() => {
    if (!items?.length) return undefined;

    const observer = new IntersectionObserver(
      entries => {
        const visible = entries
          .filter(e => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible.length) setActiveId(visible[0].target.id);
      },
      { rootMargin: '-80px 0px -60% 0px', threshold: [0.1, 0.5, 1] },
    );

    items.forEach(item => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [items]);

  return (
    <Box
      as="nav"
      aria-label={t('tableOfContents')}
      position="sticky"
      top="84px"
      pr={4}
    >
      <Text
        fontSize="xs"
        fontWeight="700"
        color="text.muted"
        textTransform="uppercase"
        letterSpacing="wider"
        mb={3}
      >
        {t('tableOfContents')}
      </Text>
      <VStack as="ul" align="stretch" spacing={1} listStyleType="none">
        {items.map(item => {
          const isActive = item.id === activeId;
          return (
            <Box as="li" key={item.id}>
              <Link
                href={`#${item.id}`}
                onClick={e => {
                  e.preventDefault();
                  document
                    .getElementById(item.id)
                    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  if (window.history?.replaceState) {
                    window.history.replaceState(null, '', `#${item.id}`);
                  }
                }}
                display="block"
                fontSize="sm"
                lineHeight="1.4"
                px={3}
                py={2}
                borderRadius="md"
                borderLeft="2px solid"
                borderColor={isActive ? 'brand.500' : 'transparent'}
                bg={isActive ? 'brand.50' : 'transparent'}
                color={isActive ? 'brand.700' : 'text.secondary'}
                fontWeight={isActive ? '600' : '400'}
                _hover={{
                  bg: isActive ? 'brand.50' : 'gray.50',
                  color: isActive ? 'brand.700' : 'text.primary',
                  textDecoration: 'none',
                }}
                transition="all 0.15s"
              >
                {item.label}
              </Link>
            </Box>
          );
        })}
      </VStack>
    </Box>
  );
};

export default TableOfContents;
